import { useLocation } from 'react-router-dom';

const useAccountType = () => {
	const location = useLocation();
	return location.pathname.includes('/individual') ? 'individual' : 'business';
};

export default useAccountType;
